import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import 'bootstrap/dist/css/bootstrap.min.css';
// import 'jquery/dist/jquery.slim.min';
// import 'popper.js/dist/umd/popper.min';
// import 'bootstrap/dist/js/bootstrap.min';

//  import '@shopify/polaris-token/styles.css';

// /multi-account/remote-admin-panel
ReactDOM.render(
    <BrowserRouter basename="/multi-account/remote-admin-panel">
        <App />
    </BrowserRouter>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
